import { render, staticRenderFns } from "./PropertyGrid.vue?vue&type=template&id=e263014c&"
import script from "./PropertyGrid.ts?vue&type=script&lang=ts&"
export * from "./PropertyGrid.ts?vue&type=script&lang=ts&"
import style0 from "./PropertyGrid.vue?vue&type=style&index=0&id=e263014c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports